import orderTypes from './order-types';

export function getViewRouteNameByOrderType(type) {
  switch (type) {
    case orderTypes.CUSTOMER:
      return 'customer-order.show';
    case orderTypes.BUSINESS:
      return 'business-order.show';
    case orderTypes.INTERNAL:
      return 'internal-order.show';
    case orderTypes.REPETITIVE_CUSTOMER:
      return 'customer-order-repetitive.show';
    case orderTypes.REPETITIVE_BUSINESS:
      return 'business-order-repetitive.show';
    default:
  }
}
